import React from 'react';
import CandidateActionsTwo from '../CandidateActionsTwo';
import SignupProcessTwo from '../SignupProcessTwo';
import PageHeader from '../PageHeader';

function BlogTwo() {
    return (
        <div>
            {/* Page Header */}
            <PageHeader
                bgImg={require('../../assets/img/businessmen-handshake.jpg')} // Ensure the image path is correct
                title="CANDIDATES"
                content="Explore our offerings and processes tailored to support you."
            />

            <div className="blog-area-wrapper sm-top">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2>What We Do for Candidates</h2>
                        </div>
                    </div>

                    <CandidateActionsTwo />

                    <div className="row">
                        <div className="col-12 text-center">
                            <h2>Our Sign Up Process</h2>
                        </div>
                    </div>

                    <SignupProcessTwo />
                </div>
            </div>
        </div>
    );
}

export default BlogTwo;
